import { Controller } from 'stimulus';

// Client welcome-video modal. Opens the configured YouTube video in a jquery-modal,
// lazy-loading the iframe on first open. On the client's first homepage visit the server
// sets auto-open, so we open it and POST a unique `seen_client_welcome_video` UserAction
// (via UserActionsController) so it never auto-opens again. The nav link reopens it anytime.
//
// The modal is referenced by id (not a Stimulus target) because jquery-modal moves the
// modal element out of this controller's DOM subtree on open, which would break
// element-scoped target lookups on reopen/reconnect.
export default class extends Controller {
  static values = { autoOpen: Boolean, modalId: String };

  connect() {
    this.modal = document.getElementById(this.modalIdValue);
    if (!this.modal) {
      return;
    }
    this.iframe = this.modal.querySelector('iframe');
    this.onClose = () => this.stop();
    $(this.modal).on($.modal.CLOSE, this.onClose);

    if (this.autoOpenValue) {
      this.open();
      this.markSeen();
    }
  }

  disconnect() {
    if (this.modal) {
      $(this.modal).off($.modal.CLOSE, this.onClose);
    }
  }

  open(event) {
    if (event) {
      event.preventDefault();
    }
    // Set the embed on open (deferred until first open since the iframe ships with no src,
    // and re-set on every open so reopening after a close reloads the video).
    this.iframe.src = this.iframe.dataset.src;
    $(this.modal).modal();
  }

  stop() {
    // Swap to about:blank on close to stop playback without loading the current page.
    this.iframe.src = 'about:blank';
  }

  markSeen() {
    fetch('/user_actions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind: 'seen_client_welcome_video' }),
    });
  }
}
